var _path, _path2, _path3, _path4, _path5, _path6, _path7, _path8, _path9, _path10, _path11, _path12;
var _excluded = ["title", "titleId"];
function _extends() { return _extends = Object.assign ? Object.assign.bind() : function (n) { for (var e = 1; e < arguments.length; e++) { var t = arguments[e]; for (var r in t) ({}).hasOwnProperty.call(t, r) && (n[r] = t[r]); } return n; }, _extends.apply(null, arguments); }
function _objectWithoutProperties(e, t) { if (null == e) return {}; var o, r, i = _objectWithoutPropertiesLoose(e, t); if (Object.getOwnPropertySymbols) { var n = Object.getOwnPropertySymbols(e); for (r = 0; r < n.length; r++) o = n[r], -1 === t.indexOf(o) && {}.propertyIsEnumerable.call(e, o) && (i[o] = e[o]); } return i; }
function _objectWithoutPropertiesLoose(r, e) { if (null == r) return {}; var t = {}; for (var n in r) if ({}.hasOwnProperty.call(r, n)) { if (-1 !== e.indexOf(n)) continue; t[n] = r[n]; } return t; }
import * as React from "react";
import { forwardRef } from "react";
var SvgHealthCheck = function SvgHealthCheck(_ref, ref) {
  var title = _ref.title,
    titleId = _ref.titleId,
    props = _objectWithoutProperties(_ref, _excluded);
  return /*#__PURE__*/React.createElement("svg", _extends({
    width: 48,
    height: 48,
    viewBox: "0 0 48 48",
    fill: "none",
    xmlns: "http://www.w3.org/2000/svg",
    ref: ref,
    "aria-labelledby": titleId
  }, props), title ? /*#__PURE__*/React.createElement("title", {
    id: titleId
  }, title) : null, _path || (_path = /*#__PURE__*/React.createElement("path", {
    d: "M4.08331 21.1339C4.15357 19.582 5.41394 18.3506 6.96679 18.3064C12.5504 18.1475 16.5423 18.1386 22.0223 18.3009C23.577 18.347 24.834 19.5845 24.8997 21.1385C25.1354 26.718 25.1175 30.7316 24.8913 36.3121C24.8284 37.8643 23.5796 39.1066 22.027 39.1608C16.5 39.3534 12.4873 39.3508 6.96371 39.1595C5.41205 39.1058 4.16291 37.866 4.09694 36.3148C3.86246 30.8007 3.82705 26.7939 4.08331 21.1339Z",
    stroke: "black",
    strokeWidth: 1.5,
    strokeMiterlimit: 10,
    strokeLinecap: "round",
    strokeLinejoin: "round"
  })), _path2 || (_path2 = /*#__PURE__*/React.createElement("path", {
    d: "M3.98975 34.2808C4.01994 35.2941 4.05788 36.3428 4.10294 37.4495C4.16612 39.0012 5.41238 40.2452 6.96423 40.3019C12.4875 40.5036 16.5001 40.5063 22.0268 40.3032C23.5795 40.2461 24.8253 38.9998 24.8856 37.4472C24.9286 36.3401 24.9643 35.2918 24.9925 34.2808",
    stroke: "black",
    strokeWidth: 1.5,
    strokeMiterlimit: 10,
    strokeLinecap: "round",
    strokeLinejoin: "round"
  })), _path3 || (_path3 = /*#__PURE__*/React.createElement("path", {
    d: "M7.60877 21.8802H21.3839C21.4769 27.307 21.4825 30.3011 21.3839 35.5663H7.60877C7.44198 30.2977 7.41882 27.3115 7.60877 21.8802Z",
    stroke: "black",
    strokeWidth: 1.125,
    strokeMiterlimit: 10,
    strokeLinecap: "round",
    strokeLinejoin: "round"
  })), _path4 || (_path4 = /*#__PURE__*/React.createElement("path", {
    d: "M7.60876 22.3829H21.3838",
    stroke: "black",
    strokeWidth: 1.125,
    strokeMiterlimit: 10,
    strokeLinecap: "round",
    strokeLinejoin: "round"
  })), _path5 || (_path5 = /*#__PURE__*/React.createElement("path", {
    d: "M7.92798 29.401H11.6321L13.8085 24.4576L15.9853 33.6529L17.1652 28.5466H21.3873",
    stroke: "black",
    strokeWidth: 1.125,
    strokeMiterlimit: 10,
    strokeLinecap: "round",
    strokeLinejoin: "round"
  })), _path6 || (_path6 = /*#__PURE__*/React.createElement("path", {
    d: "M30.6639 4.52118C29.0714 4.42404 25.7577 5.27828 25.2428 7.4752C24.5991 10.2213 25.7262 12.2185 28.8927 14.4653C32.0592 16.712 34.4743 18.3347 34.5816 23.9517",
    stroke: "black",
    strokeWidth: 1.5,
    strokeMiterlimit: 10,
    strokeLinecap: "round",
    strokeLinejoin: "round"
  })), _path7 || (_path7 = /*#__PURE__*/React.createElement("path", {
    d: "M34.5816 23.9518C34.6889 18.3348 37.104 16.7121 40.2705 14.4653C43.437 12.2186 44.5642 10.2214 43.9204 7.47527C43.5133 5.73814 41.3562 4.84048 39.6839 4.58887",
    stroke: "black",
    strokeWidth: 1.5,
    strokeMiterlimit: 10,
    strokeLinecap: "round",
    strokeLinejoin: "round"
  })), _path8 || (_path8 = /*#__PURE__*/React.createElement("path", {
    d: "M38.1034 4.51381C38.1034 5.73179 38.809 6.71916 39.6794 6.71916V2.30847C38.809 2.30847 38.1034 3.29584 38.1034 4.51381Z",
    stroke: "black",
    strokeWidth: 1.5,
    strokeMiterlimit: 10,
    strokeLinecap: "round",
    strokeLinejoin: "round"
  })), _path9 || (_path9 = /*#__PURE__*/React.createElement("path", {
    d: "M38.4521 4.51376C38.4521 5.19291 38.8456 5.74347 39.3309 5.74347V3.28406C38.8456 3.28406 38.4521 3.83462 38.4521 4.51376Z",
    stroke: "black",
    strokeWidth: 1.5,
    strokeMiterlimit: 10,
    strokeLinecap: "round",
    strokeLinejoin: "round"
  })), _path10 || (_path10 = /*#__PURE__*/React.createElement("path", {
    d: "M30.99 4.51381C30.99 5.73179 30.3044 6.71916 29.4586 6.71916V2.30847C30.3044 2.30847 30.99 3.29584 30.99 4.51381Z",
    stroke: "black",
    strokeWidth: 1.5,
    strokeMiterlimit: 10,
    strokeLinecap: "round",
    strokeLinejoin: "round"
  })), _path11 || (_path11 = /*#__PURE__*/React.createElement("path", {
    d: "M30.6509 4.51376C30.6509 5.19291 30.2686 5.74347 29.797 5.74347V3.28406C30.2686 3.28406 30.6509 3.83462 30.6509 4.51376Z",
    stroke: "black",
    strokeWidth: 1.5,
    strokeMiterlimit: 10,
    strokeLinecap: "round",
    strokeLinejoin: "round"
  })), _path12 || (_path12 = /*#__PURE__*/React.createElement("path", {
    d: "M34.5785 23.5433C34.5785 26.1938 35.3783 29.77 33.4866 33.2507C32.0644 35.5403 28.065 34.11 29.1342 29.1804C30.4707 23.0185 38.4165 25.3187 38.4165 32.2483C38.4165 38.0521 39.4912 46.9527 22.0817 45.5422C19.0415 45.2959 14.3994 43.4366 14.3995 40.6094",
    stroke: "black",
    strokeWidth: 1.5,
    strokeMiterlimit: 10,
    strokeLinecap: "round",
    strokeLinejoin: "round"
  })));
};
var ForwardRef = /*#__PURE__*/forwardRef(SvgHealthCheck);
export { ForwardRef as ReactComponent };
export default __webpack_public_path__ + "health_check.42d17e45988e4cf79c84e4ec59074bba.svg";